<template>
        <div class="popupContainer">
            <div class="content" v-if="dataSet?.serviceList.length == 0">
                    <div class="no_more">
                    <no-data :text=" $t('common.noThreeData')" :image="noRecordImg"/>
                    </div>
                </div>
            <div v-else class="serviceCard" v-for="(item, index) in dataSet?.serviceList" :key="index">
                <van-row>
                    <van-col span="4" class="avatarImage">
                        <img :src="item.avatar" alt="">
                    </van-col>
                    <van-col span="12" class="serviceTitle">{{ item.nickname }}</van-col>
                    <van-col span="8" style="display: flex; align-items: center; justify-content: right;">
                        <div class="chat_btn" @click="goToUrl(item.redirectUrl)">{{ $t('contactService.contacto') }}</div>
                    </van-col>
                </van-row>
            </div>
            <!-- <div class="chatText">{{ $t('contactService.text') }}
            </div> -->
        </div>
</template>

<script setup lang="ts">
import { ContactServiceData, goToUrl } from '@/view/profile/supportScript';
import { ref, computed, onMounted } from 'vue'
import NoData from '../components/common/noData.vue';
import noRecordImg from '@/assets/themeThree/No_record.png';


const props = defineProps<{
    dataSet: ContactServiceData
}>()

const emits = defineEmits(['open', 'close', 'update:show'])

const open = () => {
    emits('open')
}
const close = () => {
    emits('close')
}
onMounted(() => {
     emits('open')
})

defineExpose({
    open,
    close
})

</script>
<style scoped>


.van-overlay {
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    z-index: 10001 !important;
}

.van-popup::-webkit-scrollbar {
    display: none;
}

.chat_btn {
    color: #fff;
    font-size: 13px;
    background: linear-gradient(180deg, #35A5F8 0%, #0268CB 100%);
    border-radius: 5px;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    display: flex;
    text-align: center;
    justify-content: center;
    width: 90%;
}

.chatText {
    color: #fff;
    padding: 15px;
    font-size: 15px;
}

.serviceCard {
    background: #0F1426;
    /* border: 0.5px solid rgba(221, 122, 51, 0.25); */
    padding: 10px;
    border-radius: 10px;
    margin: 15px 0px;
    border-radius: 5px;
}

.avatarImage img {
    width: 90%;
}

.serviceTitle {
    font-size: 16px;
    font-weight: 300;
    color: #fff;
    display: flex;
    align-items: center;

}

.serviceCard>>>.van-cell {
    padding: 5px 15px;
    margin: 10px 0;
    background: #ffffff29;
    color: #ffffff7a;
    font-size: 15px;
}

.serviceCard>>>.van-field__control {
    color: #ffffff7a;
    font-size: 15px;
}

.ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    width: 100%;
}

@media (max-width: 360px) {
  .serviceCard {
    padding: 8px;
    margin: 10px 0;
  }

  .avatarImage img {
    width: 80%;
  }

  .serviceTitle {
    font-size: 14px;
  }

  .chat_btn {
    font-size: 11px;
    padding: 6px 10px;
    border-radius: 4px;
  }

  .chatText {
    font-size: 13px;
    padding: 10px;
  }

  .no_more {
    font-size: 12px;
  }
}
</style>